export default __webpack_public_path__ + "static/media/time.eeee7ae4.svg";